module.exports = __webpack_public_path__ + "img/f60ec68.jpg";